/**
 * @license Copyright (c) 2014-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor.js';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment.js';
import AutoImage from '@ckeditor/ckeditor5-image/src/autoimage.js';
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat.js';
import Autolink from '@ckeditor/ckeditor5-link/src/autolink.js';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote.js';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold.js';
// import CKFinder from '@ckeditor/ckeditor5-ckfinder/src/ckfinder.js';
// import CKFinderUploadAdapter from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter.js';
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials.js';
import FontBackgroundColor from '@ckeditor/ckeditor5-font/src/fontbackgroundcolor.js';
import FontColor from '@ckeditor/ckeditor5-font/src/fontcolor.js';
import FontFamily from '@ckeditor/ckeditor5-font/src/fontfamily.js';
import FontSize from '@ckeditor/ckeditor5-font/src/fontsize.js';
import Heading from '@ckeditor/ckeditor5-heading/src/heading.js';
import Highlight from '@ckeditor/ckeditor5-highlight/src/highlight.js';
import HorizontalLine from '@ckeditor/ckeditor5-horizontal-line/src/horizontalline.js';
import HtmlEmbed from '@ckeditor/ckeditor5-html-embed/src/htmlembed.js';
import Image from '@ckeditor/ckeditor5-image/src/image.js';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption.js';
// import ImageInsert from '@ckeditor/ckeditor5-image/src/imageinsert.js';
import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize.js';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle.js';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar.js';
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload.js';
import Indent from '@ckeditor/ckeditor5-indent/src/indent.js';
import IndentBlock from '@ckeditor/ckeditor5-indent/src/indentblock.js';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic.js';
import Link from '@ckeditor/ckeditor5-link/src/link.js';
import LinkImage from '@ckeditor/ckeditor5-link/src/linkimage.js';
import List from '@ckeditor/ckeditor5-list/src/list.js';
import ListStyle from '@ckeditor/ckeditor5-list/src/liststyle.js';
import MediaEmbed from '../plugins/MediaEmbedMain/src/mediaembed';
import MediaEmbedToolbar from '@ckeditor/ckeditor5-media-embed/src/mediaembedtoolbar.js';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph.js';
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice';
import RemoveFormat from '@ckeditor/ckeditor5-remove-format/src/removeformat.js';
import Strikethrough from '@ckeditor/ckeditor5-basic-styles/src/strikethrough.js';
import Subscript from '@ckeditor/ckeditor5-basic-styles/src/subscript.js';
import Superscript from '@ckeditor/ckeditor5-basic-styles/src/superscript.js';
import Table from '@ckeditor/ckeditor5-table/src/table.js';
import TableCellProperties from '@ckeditor/ckeditor5-table/src/tablecellproperties';
import TableProperties from '@ckeditor/ckeditor5-table/src/tableproperties';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar.js';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline.js';
import WordCount from '@ckeditor/ckeditor5-word-count/src/wordcount.js';

// import SliderPlus from '../plugins/SliderPlus/SliderPlus';
import Spravka from '../plugins/Spravka/spravka';
// import SliderInMaterial from "../plugins/SliderInMaterial/SliderInMaterial";
// import Opros from "../plugins/Opros/Opros";
// import Poll from "../plugins/Test/Poll";
// import InsertMedic from "../plugins/InsertMedic/InsertMedic";
import SmallCaps from '../plugins/smallCaps/small-caps';
import ImageCustom from '../plugins/ImageCustom/imagecustom';
//
// import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
// import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
//
// import formatTextIcon from '../plugins/icons/formatText.svg';
// import imageIcon from "../plugins/icons/icon_normal_text.svg";



// class FormatTextCustom extends Plugin {
//     init() {
//         const editor = this.editor;
//
//         editor.ui.componentFactory.add( 'FormatTextCustom', locale => {
//             const view = new ButtonView( locale );
//
//             view.set( {
//                 label: 'Замена кавычек и пробелов',
//                 icon: imageIcon,
//                 withText: false,
//                 tooltip: true
//             } );
//
//             // Callback executed once the image is clicked.
//             view.on( 'execute', () => {
//                 var text = editor.getData();
//                 text = text.replace(/" "/gi, '» «');
//                 text = text.replace(/""/gi, '»«');
//                 text = text.replace(/ "/gi, ' «');
//                 text = text.replace(/" /gi, '» ');
//                 text = text.replace(/>"/gi, '>«');
//                 text = text.replace(/"</gi, '»<');
//                 text = text.replace(/&nbsp;/gi, ' ');
//                 editor.setData(text);
//             } );
//
//             return view;
//         } );
//     }
// }

class Editor extends ClassicEditor {}

// Plugins to include in the build.
Editor.builtinPlugins = [
	// Alignment,
	// AutoImage,
	Autoformat,
	// Autolink,
	BlockQuote,
	Bold,
	// CKFinder,
	// CKFinderUploadAdapter,
	Essentials,
	// FontBackgroundColor,
	// FontColor,
	// FontFamily,
	// FontSize,
	// Heading,
	// Highlight,
	// HorizontalLine,
	// HtmlEmbed,
	Image,
	ImageCaption,
	// ImageInsert,
	ImageResize,
	ImageStyle,
	ImageToolbar,
	ImageUpload,
	// Indent,
	// IndentBlock,
	Italic,
	// Link,
	// LinkImage,
	// List,
	// ListStyle,
	MediaEmbed,
	MediaEmbedToolbar,
	Paragraph,
	// PasteFromOffice,
	// RemoveFormat,
	// Strikethrough,
	// Subscript,
	// Superscript,
	// Table,
	// TableCellProperties,
	// TableProperties,
	// TableToolbar,
	// Underline,
	// WordCount,
    // SmallCaps,
    // // Custom plugins
    //
    // // SliderPlus,
    // SliderInMaterial,
    // Spravka,
    // Opros,
    // Poll,
    // InsertMedic,
    // FormatTextCustom,
    // ImageCustom,
];

export default Editor;
